export type SettlementPeriod = 'month' | 'year';

export interface InsuranceType {
    id: number;
    name: string;
    settlementPeriod: SettlementPeriod;
    insuredPersonMandatory: boolean;
    pricePerSettlementPeriod: number;
}

export function isInsuranceType(o: object): o is InsuranceType {
    return (
        'id' in o &&
        typeof o.id === 'number' &&
        'name' in o &&
        typeof o.name === 'string' &&
        'settlementPeriod' in o &&
        typeof o.settlementPeriod === 'string' &&
        'insuredPersonMandatory' in o &&
        typeof o.insuredPersonMandatory === 'boolean' &&
        'pricePerSettlementPeriod' in o &&
        typeof o.settlementPeriod === 'number'
    );
}

export interface InsuranceTypeDto {
    Id: number;
    Name: string;
    SettlementPeriod: number;
    InsuredPersonsMandatory: boolean;
    PricePerSettlementPeriod: number;
}

export function dtoToInsuranceType(dto: InsuranceTypeDto): InsuranceType {
    return {
        id: dto.Id,
        name: dto.Name,
        insuredPersonMandatory: dto.InsuredPersonsMandatory,
        settlementPeriod: dto.SettlementPeriod === 2 ? 'month' : 'year',
        pricePerSettlementPeriod: dto.PricePerSettlementPeriod,
    };
}

export function insuranceTypeToDto(insuranceType: InsuranceType): InsuranceTypeDto {
    return {
        Id: insuranceType.id,
        Name: insuranceType.name,
        InsuredPersonsMandatory: insuranceType.insuredPersonMandatory,
        SettlementPeriod: insuranceType.settlementPeriod === 'month' ? 0 : 1,
        PricePerSettlementPeriod: insuranceType.pricePerSettlementPeriod,
    };
}
